(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./key.config"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./key.config"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.key);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, keys) {
  "use strict";

  var _interopRequireWildcard = require("/root/deploy/iot-gov-report/node_modules/@babel/runtime/helpers/interopRequireWildcard");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.keys = _exports.base = void 0;
  keys = _interopRequireWildcard(keys);
  _exports.keys = keys;
  var base = {
    ossHost: 'https://static.yudada.com/iotProductTool/',
    RETRY_COUNT: 3,
    RETRY_DELAY: 3000,
    BASE_URL: process.env.VUE_APP_BASE_URL,
    ENV: process.env,
    PROBE_BASE_URL: process.env.NODE_ENV == "production" ? "".concat(process.env.VUE_APP_BASE_URL, "qcTool/") : 'http://54.222.209.236:8080/',
    // PROBE_BASE_URL: process.env.NODE_ENV == "production" ? `${process.env.VUE_APP_BASE_URL}qcTool/` : 'http://192.168.50.20:8083/',
    ADMIN_URL: process.env.NODE_ENV == "production" ? "https://lansong.admin.yudada.com/" : 'https://t.lansong.admin.yudada.com/',
    DEALER_WECHAT_BASE_URL: process.env.NODE_ENV == "production" ? 'https://mp.yudada.com/dealer/' : 'https://t.mp.yudada.com/dealer/',
    // ADMIN_URL: process.env.NODE_ENV == "production" ? `https://lansong.admin.yudada.com/` : 'http://127.0.0.1:3011/',
    fList: ['yingwo', 'lexing', 'ruiyin']
  };
  _exports.base = base;
  console.log(process.env.NODE_ENV);
});